var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-row",style:({'--images': _vm.images.length})},_vm._l((_vm.images),function(image,i){return _c('div',{key:i,staticClass:"photo-row__item"},[_c('LazyImage',{attrs:{"src":image.image.source + ".jpg"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }